<template>

</template>

<script>
  export default {
    name: "ref",
    beforeRouteEnter(to, from, next) {
      next(vm => {
        vm.$router.replace(from.path)
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/view/ref.vue